<template>
    <div>
        <div v-if="loading" class="text-center">
            <i class="fa fa-circle-o-notch fa-spin"></i> Loading
        </div>

        <div v-else>
            <vue-headful :title="equipment_usage_id ? 'Edit' : 'Create' + ' Logged Equipment Usage :: MeritEHS'"/>

            <h4 class="py-3 mb-4">
                <ol class="breadcrumb font-weight-bold m-0">
                    <li class="breadcrumb-item font-weight-light">
                        <router-link :to="`/equipment`">
                            <i class="fa fa-truck"></i> Equipment
                        </router-link>
                    </li>
                    <li class="breadcrumb-item font-weight-light">
                        <router-link :to="`/equipment/view/${equipment.equipment_id}`">
                            {{ equipment.equipment_type_name }}
                            <span v-if="equipment.equipment_name">-</span> {{ equipment.equipment_name }}
                            <span v-if="equipment.model_number">-</span> {{ equipment.model_number }}
                            <span v-if="equipment.serial_number">-</span> {{ equipment.serial_number }}
                        </router-link>
                    </li>
                    <li class="breadcrumb-item active">
                        <span v-if="equipment_usage.equipment_usage_id">Edit</span>
                        <span v-else>Add</span>
                    </li>
                </ol>
            </h4>

            <div class="row">
                <div class="col-xl-9 col-lg-10 col-md-12 mb-4">
                    <div class="card">
                        <div class="card-body">
                            <div v-bind:class="{ 'form-group': true, 'has-error': errors.start_date }" class="row">
                                <label class="col-lg-3 col-md-4 col-sm-5 col-form-label text-sm-right">Start Date: <i class="fa fa-asterisk small text-danger"></i></label>
                                <div class="col-sm-8">
                                    <date-picker :value="readDate(equipment_usage.start_date)" @input="equipment_usage.start_date = writeDate($event)" :config="options"></date-picker>
                                    <span v-if="errors.start_date" class="text-danger">
                                        <span v-for="error in errors.start_date">{{ error }}</span>
                                    </span>
                                </div>
                            </div>

                            <div v-bind:class="{ 'form-group': true, 'has-error': errors.amount }" class="row">
                                <label v-if="equipment_type.use_absolute_usage" class="col-lg-3 col-md-4 col-sm-5 col-form-label text-sm-right">Current Usage: <i class="fa fa-asterisk small text-danger"></i></label>
                                <label v-else class="col-lg-3 col-md-4 col-sm-5 col-form-label text-sm-right">Logged Usage: <i class="fa fa-asterisk small text-danger"></i></label>
                                <div class="col-sm-8">
                                    <span class="input-group">
                                        <input type="number" name="amount" v-model="equipment_usage.amount" class="form-control" :placeholder="'Enter Amount' + (equipment_usage.equipment_usage_type_id ? ` of ${equipment_usage_types[equipment_usage.equipment_usage_type_id]}` : '')" />
                                        <div v-if="equipment_usage.equipment_usage_type_id" class="input-group-append">
                                            <span class="input-group-text bg-light">{{equipment_usage_types[equipment_usage.equipment_usage_type_id]}}</span>
                                        </div>
                                    </span>

                                    <span v-if="errors.amount" class="text-danger">
                                        <span v-for="error in errors.amount">{{ error }}</span>
                                    </span>
                                </div>
                            </div>

                            <div v-bind:class="{ 'form-group': true, 'has-error': errors.equipment_usage_type_id }" class="row">
                                <label class="col-lg-3 col-md-4 col-sm-5 col-form-label text-sm-right">Usage Type: <i class="fa fa-asterisk small text-danger"></i></label>
                                <div class="col-sm-8">
                                    <select name="equipment_usage_type_id" v-model="equipment_usage.equipment_usage_type_id" class="form-control">
                                        <option :value="null">-- Select a Usage Type --</option>
                                        <option v-for="(type, value) in equipment_usage_types" :value="value">{{type}}</option>
                                    </select>

                                    <span v-if="errors.equipment_usage_type_id" class="text-danger">
                                        <span v-for="error in errors.equipment_usage_type_id">{{ error }}</span>
                                    </span>
                                </div>
                            </div>

                            <div v-bind:class="{ 'form-group': true, 'has-error': errors.jobsite_id }" class="row">
                                <label :class="{'text-danger': errors.jobsite_id}"class="col-lg-3 col-md-4 col-sm-5 col-form-label text-sm-right">Jobsite:</label>
                                <div class="col-sm-8">
                                    <jobsite-select :selectedValues="SiteSelectedValues" @vselected="onJobSiteSelectUpdate"></jobsite-select>
                                    <span v-if="errors.jobsite_id" class="text-danger">
                                        <span v-for="error in errors.jobsite_id">{{ error }}</span>
                                    </span>
                                </div>
                            </div>

                            <div class="form-group row">
                                <label :class="{'col-lg-3 col-md-4 col-sm-5 col-form-label text-sm-right': true, 'text-danger': errors.description}">Description:</label>
                                <div class="col-sm-8">

                                    <b-form-textarea v-model="equipment_usage.description" :class="{'is-invalid': errors.description}" rows="4" placeholder="(Optional) Enter Description"></b-form-textarea>

                                    <span v-if="errors.description" class="text-danger">
                                        <span v-for="error in errors.description">{{ error }}</span>
                                    </span>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>

            <hr/>
            <button type="button" class="btn btn-success" v-on:click="saveEquipmentUsage()" :disabled="saving">
                <span v-if="equipment_usage_id">Update</span>
                <span v-else>Add</span>
                Logged Usage
            </button>
        </div>
    </div>
</template>


<script>
    import moment from 'moment-timezone';

    export default {
        data: function() {
            return {
                loading: true,
                saving: false,
                errors: {},
                equipment_usage_id: this.$route.params.id,
                equipment_id: this.$route.params.equipment_id,
                equipment_usage_types: {},
                equipment: {},
                equipment_usage: {},
                equipment_type: {},
                JobsiteId: 0,
                options: {
                    format: 'MM/DD/YYYY',
                    date: ""
                },
            }
        },

        computed: {
            SiteSelectedValues(){
                //check for null
                if(!this.equipment_usage.jobsite_id || this.equipment_usage.jobsite_id == null)
                {
                    //Check the store
                    if (this.equipment.jobsite_id)
                    {
                        this.equipment_usage.jobsite_id = this.equipment.jobsite_id;

                        return {JobsiteId: this.equipment.jobsite_id, JobsiteNumber: this.equipment.JobsiteNumber, JobsiteName: this.equipment.JobsiteName};
                    }
                    else if(this.$store.state.user.jobsite)
                    {
                        var jobsite = this.$store.state.user.jobsite;

                        //Set the HSE jobsite
                        this.equipment_usage.jobsite_id = jobsite.JobsiteId;

                        //Send it
                        return {JobsiteId: jobsite.JobsiteId, JobsiteNumber: jobsite.JobsiteNumber, JobsiteName: jobsite.JobsiteName};
                    }

                    //Send it
                    return null;
                }

                //Send it
                return {JobsiteId: this.equipment_usage.jobsite_id, JobsiteNumber: this.equipment_usage.JobsiteNumber, JobsiteName: this.equipment_usage.JobsiteName};
            },
        },

        methods: {
            // Convert database date to human
            readDate(date) {
                return moment(date, 'YYYY-MM-DD').format('MM/DD/YYYY');
            },

            // Convert human date to database
            writeDate(date) {
                return moment(date, 'MM/DD/YYYY').format('YYYY-MM-DD');
            },

            getEquipmentUsage: function() {
                //Get the data
                this.$http
                    .get(`equipment/usage/${this.equipment_id}/edit` + (this.equipment_usage_id ? `/${this.equipment_usage_id}` : ''))
                    .then(response => {
                        //Set all the data
                        this.equipment = response.data.equipment;
                        this.equipment_usage = response.data.equipment_usage;
                        this.equipment_usage_types = response.data.equipment_usage_types;
                        this.equipment_type = response.data.equipment_type;

                        //Set loading
                        this.loading = false;
                    })
                    .catch(err => {
                        //Log the error
                        console.log(err);
                    });
            },

            saveEquipmentUsage: function() {
                //SHow loading
                this.saving = true;

                //Reset the errors
                this.errors = {};

                //Send it
                this.$http
                    .post(`equipment/usage/${this.equipment_id}/edit` + (this.equipment_usage_id ? `/${this.equipment_usage_id}` : ''), this.equipment_usage)
                    .then(response => {
                        //Alert the user?
                        this.$toastr.success('Equipment Usage Saved');

                        //Return to main list?
                        this.$router.push(`/equipment/view/${this.equipment.equipment_id}`);
                    })
                    .catch(error => {
                        //Check for error
                        if (error.response.status === 422) {
                            //Display validation errors
                            this.errors = error.response.data
                        }
                    })
                    .then(response => {
                        //SHow loading
                        this.saving = false;
                    });
            },

            onJobSiteSelectUpdate (jobsite) {
                    //Check for null
                    if(jobsite == null)
                    {
                        //Stop
                        this.equipment_usage.jobsite_id = null;
                        return;
                    }

                    //Send the value
                    this.equipment_usage.jobsite_id = jobsite.JobsiteId;
                },
        },

        mounted() {
            this.getEquipmentUsage();
        },

    }
</script>
<style>
    .form-inline .multiselect {
        display: inline-block;
        width: auto;
    }
</style>